import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Move"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M18.75 8.25L17.6925 9.3075L19.6275 11.25H12.75V4.3725L14.6925 6.3075L15.75 5.25L12 1.5L8.25 5.25L9.3075 6.3075L11.25 4.3725V11.25H4.3725L6.3075 9.3075L5.25 8.25L1.5 12L5.25 15.75L6.3075 14.6925L4.3725 12.75H11.25V19.6275L9.3075 17.6925L8.25 18.75L12 22.5L15.75 18.75L14.6925 17.6925L12.75 19.6275V12.75H19.6275L17.6925 14.6925L18.75 15.75L22.5 12L18.75 8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Move.vue"]]);
